import axios from 'axios'
import router from '../router'

axios.defaults.timeout = 300000
 
function httpGet (path = '', data = {}) {
    let token = sessionStorage.getItem("token");
    return new Promise(function (resolve, reject) {
      axios.get(path, { params: data,  headers: {"X-Access-Token": token,"X-Requested-With":"XMLHttpRequest", "tenant_id":0}})
        .then(function (response) {
          check(response.data);
          resolve(response)
        })
        .catch(function (error) {
          console.log("httpGet errror", error)
          check(error.response);
          reject(error)
        })
    })
}

function httpPost (path = '', data = {}) {
    let token = sessionStorage.getItem("token");
    return new Promise(function (resolve, reject) {
      axios.post(path + "/", data, {headers: {"X-Access-Token": token,"X-Requested-With":"XMLHttpRequest", "tenant_id":0} })
        .then(function (response) {
          check(response.data);
          resolve(response)
        })
        .catch(function (error) {
          console.log("httpPost errror", error)
          check(error.response);
          reject(error)
        })
    })
}

function httpPut (path = '', data = {}) {
  let token = sessionStorage.getItem("token");
  return new Promise(function (resolve, reject) {
    axios.put(path + "/", data, {headers: {"X-Access-Token": token,"X-Requested-With":"XMLHttpRequest", "tenant_id":0}})
      .then(function (response) {
        check(response.data);
        resolve(response)
      })
      .catch(function (error) {
        console.log("httpFile error", error)
        check(error.response);
        reject(error)
      })
  })
}

function httpDelete (path = '', data = {}) {
  let token = sessionStorage.getItem("token");
  return new Promise(function (resolve, reject) {
  
    axios.delete(path, { params: data,  headers: {"X-Access-Token": token,"X-Requested-With":"XMLHttpRequest", "tenant_id":0}})
      .then(function (response) {
        check(response.data);
        resolve(response)
      })
      .catch(function (error) {
        console.log("httpDelete error", error)
        check(error.response);
        reject(error)
      })
  })
}


function httpFile (path = '', formData = {}) {
  let token = sessionStorage.getItem("token");
  return new Promise(function (resolve, reject) {
    axios.post(path + "/", formData, {headers: {"X-Access-Token": token,"X-Requested-With":"XMLHttpRequest", "tenant_id":0}, "Content-type":"multipart/form-data" })
      .then(function (response) {
        check(response.data);
        resolve(response)
      })
      .catch(function (error) {
        console.log("httpFile error", error)
        check(error.response);
        reject(error)
      })
  })
}


function check(res) {
    let message = res.message;
    if (res.data != null) {
      message = res.data.message;
    }
    if (message.indexOf('Token') >= 0 || message.indexOf('token') >= 0 ) {
      sessionStorage.setItem('token', "")
      sessionStorage.setItem('userId', "")
      localStorage.setItem('token', "")    
      router.push({path:'/login'})  
      return false;
      
    }
}



function downFile(urlStr, fileName) {

  let token = sessionStorage.getItem("token");
  var xhr = new XMLHttpRequest()
  xhr.open('GET', urlStr, true);
  xhr.responseType = 'blob';
  xhr.setRequestHeader("token",token); // 请求头中的验证信息等（如果有）
  xhr.onload = function(res) {
      if (this.status === 200) {
          var type = xhr.getResponseHeader('Content-Type');
          console.log('type',type)
          var blob = new Blob([this.response], {type: type});
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(blob, fileName);
          } else {
              var URL = window.URL || window.webkitURL;
              var objectUrl = URL.createObjectURL(blob);
              if (fileName) {
                  var a = document.createElement('a');
                  if (typeof a.download === 'undefined') {
                      window.location = objectUrl;
                  } else {
                      a.href = objectUrl;
                      a.download = fileName;
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                  }
              } else {
                  window.location = objectUrl;
              }
          }
      }
  }
  xhr.send()
}

 



export  {
    httpGet, httpPost,httpPut, httpDelete,httpFile,downFile
}




// WEBPACK FOOTER //
// ./src/utils/httpUtils.js